import axios from 'axios';
import { from } from 'rxjs';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_FIDIC } from 'settings';
import type { FidicContract } from 'v2/interfaces/fidic';

class FidicService {
  public static async checkContractAgreement(clientId: number): Promise<FidicContract> {
    const response = await axios({
      url: API_FIDIC + '/public/users/check-status/' + clientId,
      method: 'GET'
    });

    return response.data;
  }

  public checkFidcApi(clientId: number): Observable<FidicContract> {
    return from(
      axios({
        url: API_FIDIC + '/public/users/check-status/' + clientId,
        method: 'GET'
      })
    ).pipe(map(response => response.data));
  }
}

const fidcStatusService = new FidicService();
export default fidcStatusService;
